// src/hooks/coinglass/useETFInflows.ts

import { useQuery } from "@tanstack/react-query";
import { etfInflowsHistoryQueryOptions } from "@/services/queries/coinglass/coinglassQueries";
import type { ETFNetInflowRow } from "@/types/etf";

/**
 * Custom hook for fetching ETF net inflow data
 *
 * @param ticker - Token ticker symbol (lowercase: "btc", "eth", "sol")
 * @returns Query result with ETF inflow data
 *
 * @example
 * ```tsx
 * const { data, isLoading, error } = useETFInflows("btc");
 * ```
 */
export function useETFInflows(ticker: string) {
  const query = useQuery(etfInflowsHistoryQueryOptions({ ticker }));

  // Transform API response to match our UI interface
  const data: ETFNetInflowRow[] = query.data?.data || [];

  return {
    ...query,
    data,
  };
}
